/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Col, Layout, Row, Skeleton, notification } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../axios_instance';
import PaginationComponent from '../../../general/pagination';
import SkillSearchComponent from '../../../general/search/skill-search';
import SkillAddModal from '../../../uicontainers/admin/add-skill';
import SkillCategoryAddModal from '../../../uicontainers/admin/add-category';
import SkillList from '../../../uicontainers/admin/skill-list';
import styles from './styles.module.scss';
import { SkillSearchCriteriaList } from '../../../../utils/option-list';

// const style: React.CSSProperties = { background: '#0092ff', padding: '8px 0' };

const SkillListView: React.FC = (): JSX.Element => {
  const [skillList, setSkillList] = useState<Array<any>>([]);
  const [page, setPage] = useState<number>(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [url, setUrl] = useState<string>(`/api/v1/admin/paginated/skills?`);
  const [addNew, setAddNew] = useState<boolean>(false);
  const [addCategoryOpen, setAddCategoryOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const openNotification = (
    notificationType: 'success' | 'info' | 'warning' | 'error'
  ) => {
    notification[notificationType]({
      message: 'An error occurred!List can not load right now!',
    });
  };

  useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(url + 'page-number=' + page)
      .then((response) => {
        setSkillList(response.data.items);
        setTotal(response.data['total_items']);
      })
      .catch((error) => {
        openNotification('error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(
        url.charAt(url.length - 1) === '&' ? url.slice(0, url.length - 1) : url
      )
      .then((response) => {
        setSkillList(response.data.items);
        setTotal(response.data['total_items']);
      })
      .catch((error) => {
        openNotification('error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [url]);
  useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(
        url +
          (url.charAt(url.length - 1) === '?'
            ? 'page-number='
            : '&page-number=') +
          page
      )
      .then((response) => {
        setSkillList(response.data.items);
      })
      .catch((error) => {
        openNotification('error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [page]);

  return (
    <>
      <h1 className={styles['page-title']}>Skills</h1>
      <Button
        className={styles['add-new-button']}
        onClick={(e) => {
          setAddNew(true);
        }}
      >
        Add Skill
      </Button>
      <Button
        className={styles['add-category-button']}
        onClick={(e) => {
          setAddCategoryOpen(true);
        }}
      >
        Add Category
      </Button>
      <SkillAddModal isModalOpen={addNew} setIsModalOpen={setAddNew} />
      <SkillCategoryAddModal isModalOpen={addCategoryOpen} setIsModalOpen={setAddCategoryOpen} />
      <div style={{ position: 'fixed', top: '164px', width: '80%', zIndex: 2 }}>
        <Row align={'middle'}>
          <Col span={12}>
            <SkillSearchComponent
              {...{ setUrl, setPage }}
              baseUrl={`/api/v1/admin/paginated/skills/`}
              searchCriteriaList={SkillSearchCriteriaList}
            />
          </Col>
          <Col>
            <span
              style={{
                marginLeft: '20px',
                color: '#9E9E9E',
                fontFamily: 'Open Sans',
                fontWeight: '400',
              }}
            >
              {total + ' skills found'}
            </span>
          </Col>
        </Row>

        <br />
      </div>

      {/* <EmployeeList employeeList={employeeList.slice((page-1)*pageSize,Math.min(employeeList.length, page*pageSize))}/> */}
      <div
        style={{
          height: '226px',
          width: '100%',
          position: 'fixed',
          top: 1,
          background: '#f9fafd',
          zIndex: 1,
        }}
      ></div>
      {/* <div style={{marginTop:"216px"}}> */}
      {/* <EmployeeList employeeList={setSkillList} /> */}
      {/* </div> */}
      {isLoading ? (
        <Layout className={styles.layout}>
          <Content className={styles.container}>
            <Skeleton active /> <Skeleton active /> <Skeleton active />
          </Content>
        </Layout>
      ) : (
        <SkillList skillList={skillList} />
      )}

      <div
        style={{
          marginLeft: 'auto',
          marginRight: '10px',
          marginTop: '10px',
          marginBottom: '20px',
          float: 'right',
        }}
      >
        <PaginationComponent
          pageNumber={page}
          total={total}
          setPageNumber={setPage}
          pageSize={pageSize}
        />
      </div>
    </>
  );
};

export default SkillListView;
